/**
 * @flow
 * @relayHash 6e3c2d26ca2f6dc54a9c20679867e34c
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ProjectPhaseCreateInput = {|
  name: string,
  color: string,
|};
export type CreateProjectPhaseMutationVariables = {|
  data: ProjectPhaseCreateInput
|};
export type CreateProjectPhaseMutationResponse = {|
  +createProjectPhase: {|
    +id: string
  |}
|};
export type CreateProjectPhaseMutation = {|
  variables: CreateProjectPhaseMutationVariables,
  response: CreateProjectPhaseMutationResponse,
|};
*/


/*
mutation CreateProjectPhaseMutation(
  $data: ProjectPhaseCreateInput!
) {
  createProjectPhase(data: $data) {
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "data",
    "type": "ProjectPhaseCreateInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "createProjectPhase",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "data",
        "variableName": "data"
      }
    ],
    "concreteType": "ProjectPhaseModel",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "CreateProjectPhaseMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "CreateProjectPhaseMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "CreateProjectPhaseMutation",
    "id": null,
    "text": "mutation CreateProjectPhaseMutation(\n  $data: ProjectPhaseCreateInput!\n) {\n  createProjectPhase(data: $data) {\n    id\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '93ec9db5f43c9390bb9bba00fb45c190';
module.exports = node;
